<template>
  <v-card flat>
    <form @submit.prevent="update" @keydown="form.onKeydown($event)">
      <v-card-title primary-title>
        <h5 class="subheading mb-0">{{ $t('profile') }}</h5>
      </v-card-title>
      <v-card-text>

        <v-container grid-list-md>
          <v-layout wrap>

              <!-- Nacionalidad -->
              <v-flex xs2 sm2 md2>
                <v-select
                  disabled
                  v-validate="'required|max:1'"
                  :items="nacionality"
                  v-model="form.nacionality"
                  :error-messages="errors.collect('nacionality')"
                  :label="$t('nacionality')"
                  data-vv-name="nacionality"
                ></v-select>
              </v-flex>

              <!-- Cédula -->
              <v-flex xs12 sm4 md2>
                <text-input
                  disabled
                  :form="form"
                  :label="$t('number_id')"
                  :v-errors="errors"
                  counter="12"
                  :value.sync="form.number_id"
                  prepend="person"
                  name="number_id"
                  v-validate="'required|max:12'"
                ></text-input>
              </v-flex>

              <!-- Name -->
              <v-flex xs12 sm8 md8>
                <div>
                  <div class="v-input v-text-field v-input--is-label-active v-input--is-dirty theme--light">
                    <div class="v-input__control">
                      <div class="v-input__slot">
                        <div class="v-text-field__slot">
                          <label aria-hidden="true" class="v-label v-label--active theme--light" style="left: 0px; right: auto; position: absolute;">Nombre</label>
                          <input disabled aria-label="Nombre" name="name" type="text" :value="form.name">
                        </div>
                      </div>
                      <div class="v-text-field__details">
                        <div class="v-messages theme--light">
                          <div class="v-messages__wrapper"></div>
                        </div>
                        <!-- <div class="v-counter theme--light">16 / 200</div> -->
                      </div>
                    </div>
                  </div> <!---->
                </div>
                <!-- <text-input
                  :form="form"
                  label="Nombre"
                  :v-errors="errors"
                  :value.sync="form.name"
                  counter="200"
                  name="name"
                  v-validate="'required|max:200'"
                ></text-input> -->
              </v-flex>

              <!-- Email -->
              <v-flex xs12 sm8 md8>
                <email-input
                  disabled
                  :form="form"
                  :label="$t('email')"
                  :v-errors="errors"
                  :value.sync="form.email"
                  name="email"
                  v-validate="'required|email'"
                ></email-input>
              </v-flex>

              <!-- Género -->
              <v-flex xs4 sm4 md4>
                <v-select
                  disabled
                  v-validate="'required'"
                  :items="gender"
                  v-model="form.gender"
                  :error-messages="errors.collect('gender')"
                  label="Genero *"
                  data-vv-name="gender"
                  required
                ></v-select>
              </v-flex>

              <!-- Fecha de Nacimiento -->
              <v-flex xs4 sm4 md4>
                <v-menu
                disabled
                ref="menu1"
                :close-on-content-click="false"
                v-model="menu1"
                data-vv-name="birthdate"
                name="birthdate"
                :error-messages="errors.collect('birthdate')"
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                max-width="290px"
                min-width="290px"
              >
              <v-text-field
                  disabled
                  slot="activator"
                  v-model="computedDateFormatted"
                  label="Nacimiento"
                  hint="DD/MM/YYYY"
                  persistent-hint
                  prepend-icon="event"
                  readonly
                ></v-text-field>
                <v-date-picker disabled v-model="form.birthdate" no-title @input="menu1 = false"></v-date-picker>
                </v-menu>
              </v-flex>

              <!-- Teléfono Casa -->
              <v-flex xs12 sm6 md4>
                <text-input
                  disabled
                  :form="form"
                  label="Hogar"
                  :v-errors="errors"
                  counter="12"
                  :value.sync="form.home_phone"
                  prepend="contact_phone"
                  name="home_phone"
                  v-validate="'max:12'"
                ></text-input>
              </v-flex>

              <!-- Teléfono de oficina -->
              <v-flex xs12 sm6 md4>
                <text-input
                  disabled
                  :form="form"
                  label="Oficina"
                  :v-errors="errors"
                  counter="12"
                  :value.sync="form.office_phone"
                  prepend="phone"
                  name="office_phone"
                  v-validate="'max:12'"
                ></text-input>
              </v-flex>

              <!-- Móvil -->
              <v-flex xs12 sm6 md4>
                <text-input
                  disabled
                  :form="form"
                  label="Celular"
                  :v-errors="errors"
                  counter="12"
                  :value.sync="form.movil"
                  prepend="phone_android"
                  name="movil"
                  v-validate="'max:12'"
                ></text-input>
              </v-flex>

              <!-- Direccion -->
              <v-flex xs12 sm8 md8>
                <text-input
                  disabled
                  :form="form"
                  label="Dirección"
                  :v-errors="errors"
                  :value.sync="form.direccion_fiscal"
                  counter="250"
                  name="direccion_fiscal"
                ></text-input>
              </v-flex>

            </v-layout>
          </v-container>
          <small>* Campos requeridos</small>
      </v-card-text>
      <v-card-actions>
        <!-- <submit-button :flat="true" :form="form" :label="$t('update')"></submit-button> -->
      </v-card-actions>
    </form>
  </v-card>
</template>

<script>
import Form from 'vform'
import { mapGetters } from 'vuex'

export default {
  name: 'profile-view',
  props: {
  },
  data: vm => ({
    gender: ['MASCULINO','FEMENINO'],
    nacionality: ['V','E', 'P'],
    form: new Form({
      name: '',
      email: '',
      number_id: '',
      gender: '',
      nacionality: '',
      birthdate: '',
      home_phone: '',
      office_phone: '',
      movil: '',
      rif: '',
      direccion_fiscal: ''
    }),
    date: '',
    dateFormatted: vm.formatDate(new Date().toISOString().substr(0, 10)),
    menu1: false,
  }),

  computed: {
    ...mapGetters({
      user: 'authUser'
    }),

    computedDateFormatted () {
      return this.formatDate(this.form.birthdate)
    }
  },

  created () {
    // Fill the form with user data.
    this.form.keys().forEach(key => {
      this.form[key] = this.user[key]
    })
  },

  methods: {
    async update () {
      if (await this.formHasErrors()) return

      this.$emit('busy', true)

      const { data } = await this.form.patch('/api/settings/profile')
      await this.$store.dispatch('updateUser', { user: data })
      this.$emit('busy', false)

      this.$store.dispatch('responseMessage', {
        type: 'success',
        text: this.$t('info_updated')
      })
    },

    formatDate (date) {
        if (!date) return null

        const [year, month, day] = date.split('-')
        return `${day}/${month}/${year}`
    },

    parseDate (date) {
        if (!date) return null

        const [day, month, year] = date.split('/')
        return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    }

  }
}
</script>




// WEBPACK FOOTER //
// resources/assets/js/pages/settings/profile.vue